// extracted by mini-css-extract-plugin
export default {"attemdence_summray_title":"style_attemdence_summray_title__hZsn7","attemdence_summray_percent":"style_attemdence_summray_percent__eNsV-"};